import { StyleSheet } from '@/core/StyleSheet';

export default StyleSheet.create({
	picker: {
		alignItems: 'center',
		flexDirection: 'row',
		display: 'flex',
	},
	label: {
		color: '$inputBorderColor__Focused',
		fontSize: 16,
		textAlign: 'right',
		marginRight: 5,
	},
	save: {
		color: '$inputBorderColor__Focused',
		display: 'flex',
		justifyContent: 'center',
		padding: 5,
	},
	select: {
		flex: 1,
	},
	timeSlots: {
		paddingBottom: 15,
	},
});
